import { baseApi } from './../baseApi';
import { TournamentCalendarModel } from '../../models/tournamentCalendarModel';
import { cleanObject } from '../../utils/objectUtils';

export async function getTournamentCalendarReq(
  pagingDirection?: string,
  fromSorterId?: string,
  fromDate?: string,
  textSearch?: string,
  maxResults?: number,
) {
  let url = '/officiating/tournament-calendar?';
  let queryParamsObj = cleanObject({
    pagingDirection,
    fromSorterId,
    fromDate,
    textSearch,
    maxResults,
  });
  const queryParams = new URLSearchParams(queryParamsObj);

  return baseApi.get<TournamentCalendarModel[]>(url + queryParams);
}

export async function getTournamentDetailsReq(tournamentId: string) {
  return baseApi.get<TournamentCalendarModel>(
    `/officiating/tournament-calendar/single/${tournamentId}`,
  );
}

export async function getMyTournamentsReq() {
  return baseApi.get<TournamentCalendarModel[]>(`/officiating/tournament-calendar/my-tournaments`);
}
export async function getPersonTournamentsReq(personId: string) {
  let url = '/officiating/tournament-calendar/other?';
  let queryParamsObj = cleanObject({
    personId,
  });
  const queryParams = new URLSearchParams(queryParamsObj);

  return baseApi.get<TournamentCalendarModel[]>(url + queryParams);
}
